import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Import CSS files for FontAwesome, Bootstrap, and MDBReact
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

// Render the App component to the 'root' element in the HTML
ReactDOM.render(<App />, document.getElementById('root'));

// Optional: If you want your app to work offline and load faster,
// you can change unregister() to register() below.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

